import { useState } from "react";

import styled from "styled-components/macro";

import { usePaymentForm } from "Payments/PaymentPage/PaymentFormScreen/PaymentFormContext";
import { SectionIconWrapper } from "Payments/PaymentPage/PaymentFormScreen/styles";
import { motion } from "framer-motion";

import FnrIcon from "UI/FnrIcon";
import { colors } from "UI/colors";

import CardIcon from "./CardIcon";

export default function PaymentMethodIcon() {
  const {
    state: { formStages },
  } = usePaymentForm();

  const [backgroundColor] = useState(colors.fnGray);

  const hideIcon =
    formStages.paymentInfo === "chooseAddMethodType" ||
    formStages.paymentInfo === "addCard";

  return (
    <IconWrapper
      initial={{
        width: hideIcon ? 0 : 74,
      }}
      animate={{
        width: hideIcon ? 0 : 74,
      }}
    >
      <SectionIconWrapper style={{ backgroundColor }}>
        {formStages.paymentInfo === "methodSelected" ? (
          <CardIcon />
        ) : (
          <FnrIcon fas fa-credit-card />
        )}
      </SectionIconWrapper>
    </IconWrapper>
  );
}

const IconWrapper = styled(motion.div)`
  flex-grow: 0;
  flex-shrink: 0;
  align-self: flex-start;
  display: flex;
  justify-content: flex-end;
  overflow: hidden;
`;
